export { default as SerpSellingPriceSlot } from './SerpSellingPriceSlot';
